const slots = [
    {
      flex: 1,
      defaultIndex: 18,
      values: [{
        "label": "北京市",
        "value": "11",
        "index": "0"
      },
      {
        "label": "天津市",
        "value": "12",
        "index": "1"
      },
      {
        "label": "河北省",
        "value": "13",
        "index": "2"
      },
      {
        "label": "山西省",
        "value": "14",
        "index": "3"
      },
      {
        "label": "内蒙古",
        "value": "15",
        "index": "4"
      },
      {
        "label": "辽宁省",
        "value": "21",
        "index": "5"
      },
      {
        "label": "吉林省",
        "value": "22",
        "index": "6"
      },
      {
        "label": "黑龙江省",
        "value": "23",
        "index": "7"
      },
      {
        "label": "上海市",
        "value": "31",
        "index": "8"
      },
      {
        "label": "江苏省",
        "value": "32",
        "index": "9"
      },
      {
        "label": "浙江省",
        "value": "33",
        "index": "10"
      },
      {
        "label": "安徽省",
        "value": "34",
        "index": "11"
      },
      {
        "label": "福建省",
        "value": "35",
        "index": "12"
      },
      {
        "label": "江西省",
        "value": "36",
        "index": "13"
      },
      {
        "label": "山东省",
        "value": "37",
        "index": "14"
      },
      {
        "label": "河南省",
        "value": "41",
        "index": "15"
      },
      {
        "label": "湖北省",
        "value": "42",
        "index": "16"
      },
      {
        "label": "湖南省",
        "value": "43",
        "index": "17"
      },
      {
        "label": "广东省",
        "value": "44",
        "index": "18"
      },
      {
        "label": "广西",
        "value": "45",
        "index": "19"
      },
      {
        "label": "海南省",
        "value": "46",
        "index": "20"
      },
      {
        "label": "重庆市",
        "value": "50",
        "index": "21"
      },
      {
        "label": "四川省",
        "value": "51",
        "index": "22"
      },
      {
        "label": "贵州省",
        "value": "52",
        "index": "23"
      },
      {
        "label": "云南省",
        "value": "53",
        "index": "24"
      },
      {
        "label": "西藏自治区",
        "value": "54",
        "index": "25"
      },
      {
        "label": "陕西省",
        "value": "61",
        "index": "26"
      },
      {
        "label": "甘肃省",
        "value": "62",
        "index": "27"
      },
      {
        "label": "青海省",
        "value": "63",
        "index": "28"
      },
      {
        "label": "宁夏",
        "value": "64",
        "index": "29"
      },
      {
        "label": "新疆",
        "value": "65",
        "index": "30"
      },
      {
        "label": "台湾",
        "value": "66",
        "index": "31"
      },
      {
        "label": "香港",
        "value": "67",
        "index": "32"
      },
      {
        "label": "澳门",
        "value": "68",
        "index": "33"
      }
    ],
      className: 'slot1',
      textAlign: 'right'
    }, {
      divider: true,
      content: '-',
      className: 'slot2'
    }, {
      flex: 1,
      values: [{
        "label": "广州市",
        "value": "4401",
        "index": "0"
      },
      {
        "label": "韶关市",
        "value": "4402",
        "index": "1"
      },
      {
        "label": "深圳市",
        "value": "4403",
        "index": "2"
      },
      {
        "label": "珠海市",
        "value": "4404",
        "index": "3"
      },
      {
        "label": "汕头市",
        "value": "4405",
        "index": "4"
      },
      {
        "label": "佛山市",
        "value": "4406",
        "index": "5"
      },
      {
        "label": "江门市",
        "value": "4407",
        "index": "6"
      },
      {
        "label": "湛江市",
        "value": "4408",
        "index": "7"
      },
      {
        "label": "茂名市",
        "value": "4409",
        "index": "8"
      },
      {
        "label": "肇庆市",
        "value": "4412",
        "index": "9"
      },
      {
        "label": "惠州市",
        "value": "4413",
        "index": "10"
      },
      {
        "label": "梅州市",
        "value": "4414",
        "index": "11"
      },
      {
        "label": "汕尾市",
        "value": "4415",
        "index": "12"
      },
      {
        "label": "河源市",
        "value": "4416",
        "index": "13"
      },
      {
        "label": "阳江市",
        "value": "4417",
        "index": "14"
      },
      {
        "label": "清远市",
        "value": "4418",
        "index": "15"
      },
      {
        "label": "东莞市",
        "value": "4419",
        "index": "16"
      },
      {
        "label": "中山市",
        "value": "4420",
        "index": "17"
      },
      {
        "label": "潮州市",
        "value": "4451",
        "index": "18"
      },
      {
        "label": "揭阳市",
        "value": "4452",
        "index": "19"
      },
      {
        "label": "云浮市",
        "value": "4453",
        "index": "20"
      }
    ],
      className: 'slot3',
      textAlign: 'center'
    }, {
      divider: true,
      content: '-',
      className: 'slot4'
    }, {
      flex: 1,
      values: [{
        "label": "荔湾区",
        "value": "440103"
      },
      {
        "label": "越秀区",
        "value": "440104"
      },
      {
        "label": "海珠区",
        "value": "440105"
      },
      {
        "label": "天河区",
        "value": "440106"
      },
      {
        "label": "白云区",
        "value": "440111"
      },
      {
        "label": "黄埔区",
        "value": "440112"
      },
      {
        "label": "番禺区",
        "value": "440113"
      },
      {
        "label": "花都区",
        "value": "440114"
      },
      {
        "label": "南沙区",
        "value": "440115"
      },
      {
        "label": "从化区",
        "value": "440117"
      },
      {
        "label": "增城区",
        "value": "440118"
      }
    ],
      className: 'slot5',
      textAlign: 'left'
    }
]

export default slots



// WEBPACK FOOTER //
// ./src/util/area/slots.js